
  <div class="fluid-container p-4 font-name">
  <div class="row align-items-center gap-3 mb-2 justify-content-between">
    <div class="col-auto back-btn" 
    routerLink="/student-dashboard/resume">
      <i class="bi bi-arrow-left"></i> Back
    </div>

    <div class="col-auto">
      Step {{ currentStep + 1 }} of {{ steps.length }}
    </div>
  </div>


  <div class="progress-container mb-3">
    <div 
      class="progress-bar"
      [style.width.%]="((currentStep + 1) / steps.length) * 100">
    </div>
  </div>


  <div class="tabs-container mb-3">
    <button
      *ngFor="let step of steps; let i = index"
      class="tab"
      [ngClass]="{
        'active': currentStep === i,
        'completed': isCompleted(i)
      }"
      (click)="goToStep(i)">
      <i class="bi" [ngClass]="step.icon"></i>
      {{ step.label }}

      <span *ngIf="isCompleted(i)">✔</span>
    </button>
  </div>

  <div class="content-box">
    <ng-container [ngSwitch]="currentStep">
      <app-resumer-builder-setup *ngSwitchCase="0"></app-resumer-builder-setup>
      <app-resumer-builder-personal *ngSwitchCase="1"></app-resumer-builder-personal>
      <app-resumer-builder-education *ngSwitchCase="2"></app-resumer-builder-education>
      <app-resumer-builder-skills *ngSwitchCase="3"></app-resumer-builder-skills>
      <app-resumer-builder-projects *ngSwitchCase="4"></app-resumer-builder-projects>
      <app-resumer-builder-experience *ngSwitchCase="5"></app-resumer-builder-experience>
      <app-resumer-builder-extras *ngSwitchCase="6"></app-resumer-builder-extras>
      <app-resumer-builder-summary *ngSwitchCase="7"></app-resumer-builder-summary>
    </ng-container>
  </div>

  <div class="d-flex align-items-center justify-content-between mt-3"
    [ngClass]="{
    'justify-content-between': currentStep !== 0,
    'justify-content-end': currentStep === 0
    }">
    <button class="btn-cnl" (click)="prevStep()" [disabled]="isLoading"
      *ngIf="currentStep !== 0">
      <i class="bi bi-chevron-left"></i>
      Previous</button>

      <button class="btn-add" (click)="nextStep()" [disabled]="isLoading || !isCurrentStepValid()">
        <i *ngIf="isLoading" class="bi bi-arrow-repeat spin"></i>
        <span> {{ isLoading   ? 'Saving...'  : (isLastStep() ? 'Finish & Preview' : 'Next') }}</span>
        <i class="bi bi-chevron-right"></i>
      </button>

  </div>
  </div>